import { gql } from '@apollo/client';

const hello = gql`
    query hello {
        hello
    }
`;

// multilingualCoursesEnabled is read alongside the Locales because an instance
// with the feature off still returns its Locales, and offering a choice there
// would build a snippet that cannot translate anything.
const locales = gql`
    query locales {
        store {
            multilingualCoursesEnabled
        }
        locales(order: { field: name, direction: asc }) {
            edges {
                node {
                    id
                    code
                    name
                }
            }
        }
    }
`;

export default {
    hello,
    locales,
};
